import { Modal } from "@/shared/ui/modal"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { closeEditVacancyFormModal, fetchCurrentVacancy, selectCurrentVacancy, selectIsEditVacancyFormModalOpen, selectOnFormEdit } from "../../model"
import { AddFormfield, FormField } from "@/features/formbuilder"
import { deleteProfileField, IProfileField } from "@/shared/api/profilebuilder"
import notify from "@/shared/lib/notify"

export const EditVacancyFormModal = () => {
    const isOpen = useAppSelector(selectIsEditVacancyFormModalOpen)
    const dispatch = useAppDispatch()
    const { form } = useAppSelector(selectCurrentVacancy)
    const onFormEdit = useAppSelector(selectOnFormEdit)

    const handleClose = () => {
        dispatch(closeEditVacancyFormModal())
    }

    const onUpdate = () => {
        dispatch(fetchCurrentVacancy())
        onFormEdit()
    }

    const handleDelete = async (field: IProfileField) => {
        await deleteProfileField(field.id)
            .then(() => onUpdate())
            .catch(() => notify.error('Не удалось удалить поле анкеты'))
    }

    return (
        <Modal
            isOpen={isOpen}
            title="ИЗМЕНЕНИЕ АНКЕТЫ"
            onRequestClose={handleClose}       
        >
            <div className="flex flex-col gap-3">
                <div className="w-full max-h-[80vh] overflow-y-scroll flex flex-col gap-3">
                    {Boolean(form.template.length) &&
                        form.template.map((field, index) => 
                            <FormField index={index} onUpdate={onUpdate} handleDelete={() => handleDelete(field)} key={field.id} field={field}/>
                        )
                    }
                    {!Boolean(form.template.length) &&
                        <div className="font-semibold text-lg uppercase text-color-primary">
                            Нет полей для ввода
                        </div>
                    }
                </div>
                <AddFormfield index={form.template.length} formId={form.id} update={onUpdate} />
                <button onClick={handleClose} className="form_cancel_button">
                    Закрыть
                </button>
            </div>
        </Modal>
    )
}